import Renderer from './Renderer';

export default class AnimateRenderer extends Renderer {
    constructor(canvasElement, svgElement, statContainer) {
        super(canvasElement, svgElement, statContainer);
    }
}
